import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const PortfolioTemplate = () => {
    useEffect(() => {
        document.title = 'Portfolio Template -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics  </li> 
                 <li>Portfolio Template </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Portfolio Template  </h1>
                    </div>
                </div>
                <div className="row"> 
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/PortfolioTemplate.pdf" target="_blank">   PORTFOLIO TEMPLATE
                            </Link> </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default PortfolioTemplate